module.exports = __webpack_public_path__ + "img/telefonos-nn-1.46fa0d10.svg";